import { render, staticRenderFns } from "./SelectOrderPayer.vue?vue&type=template&id=2f55d766&"
import script from "./SelectOrderPayer.vue?vue&type=script&lang=js&"
export * from "./SelectOrderPayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports